<template>
  <div>
    <v-snackbar v-model="hideActionsTable" :timeout="0" :multi-line="true">
      Sort data
      <v-card-actions v-if="sort_data == true">
        <v-btn
          @click="cancelSortData()"
          :loading="cancel_sort"
          :disabled="cancel_sort || sorting_data || fetching_data"
          color="red"
          dark
          >Cancel</v-btn
        >
        <!-- v-if="sort_data == true" -->
        <v-btn
          @click="saveSort()"
          :loading="sorting_data"
          :disabled="sorting_data || cancel_sort || fetching_data"
          color="green"
          dark
          >Apply sort</v-btn
        >
        <label v-if="sort_msg == 3">Can't sort</label>
        <!-- v-else-if="sort_data == true" -->
      </v-card-actions>
    </v-snackbar>
    <v-btn
      absolute
      dark
      fab
      top
      right
      v-if="!sort_data"
      :disabled="sorting_data || cancel_sort"
      color="primary"
      style="top: 10px"
      @click="bannerDialog = true"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <bannerForm
      :isLoadingStore="isLoadingStore"
      :form="form"
      @setForm="
        form = {
          banner_promotion_image: null,
          banner_promotion_store: [0],
        }
      "
      :dialog="bannerDialog"
      @setDialog="bannerDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      @cancel="cancelBannerForm()"
    />
    <h1 class="text-pagename">Set banner promotion on app</h1>
    <v-layout row>
      <v-flex xs6 class="text-xs-left">
        <v-toolbar dense flat>
          <v-btn @click="startSort()" v-if="sort_data == false" round dark
            >Start sort</v-btn
          >
        </v-toolbar>
      </v-flex>
      <v-flex xs6>
        <v-toolbar dense flat>
          <v-text-field
            :disabled="sort_data"
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :loading="fetching_data"
      :headers="headers"
      :items="promotion_banner"
      :hide-actions="hideActionsTable"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="px-1 handle" style="width: 0.1%" v-if="sort_data == true">
          <v-btn style="cursor: move" icon :disabled="sorting_data">
            <v-icon>drag_indicator</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center" v-else>
          {{ promotion_banner.indexOf(props.item) + 1 }}
        </td>
        <td style="padding: 6px 0 0 0">
          <img
            :src="props.item.banner_promotion_image"
            width="245px"
            height="100px"
          />
        </td>
        <td class="text-xs-center">{{ filterPromotionType(props.item) }}</td>
        <td class="text-xs-center">{{ props.item.banner_promotion_name }}</td>
        <td class="text-xs-center">
          {{ props.item.banner_promotion_date_start }}
        </td>
        <td class="text-xs-center">
          {{ props.item.banner_promotion_date_end }}
        </td>
        <td class="text-xs-center" style="position: relative">
          <v-switch
            v-if="!sort_data"
            @change="changeStatusBanner(props.item)"
            v-model="props.item.banner_promotion_status"
            color="primary"
            class="status_toggle"
          ></v-switch>
        </td>
        <td class="text-xs-center" style="position: relative">
          <v-tooltip top>
            <v-btn
              v-if="!sort_data"
              :disabled="sorting_data || cancel_sort"
              icon
              @click="editBanner(props.item)"
              slot="activator"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              v-if="!sort_data"
              icon
              slot="activator"
              @click="deleteBanner(props.item)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="fetching_data == false">No data available</div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import Sortable from "sortablejs";
import bannerForm from "./BannerForm";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    bannerForm,
  },
  data() {
    return {
      isLoadingStore: false,
      hideActionsTable: false,
      data_for_sort: {},
      sort_data: false,
      sort_msg: 0,
      cancel_sort: false,
      sorting_data: false,
      original_data: {},
      form: {
        banner_promotion_image: null,
        banner_promotion_store: [0],
      },
      fetching_data: false,
      search: "",
      pagination: { rowsPerPage: 5 },
      bannerDialog: false,
      dialog: false,
      editedIndex: -1,
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "id",
        },
        {
          text: "Image",
          align: "center",
          sortable: false,
          value: "banner_img",
        },
        {
          text: "Order type",
          align: "center",
          sortable: false,
          value: "banner_promotion_type_name_temp",
        },
        {
          text: "Banner name",
          align: "center",
          sortable: false,
          value: "banner_promotion_name",
        },
        {
          text: "Start date",
          align: "center",
          value: "banner_promotion_date_start",
          sortable: false,
        },
        {
          text: "End date",
          align: "center",
          value: "banner_promotion_date_end",
          sortable: false,
        },
        {
          text: "Change status",
          align: "center",
          value: "status",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          value: "action",
          sortable: false,
        },
      ],
      desserts: [
        {
          id: 1,
          banner_img: "",
          banner_name: "Frozen Yogurt",
          start_date: 24,
          end_date: 4.0,
          statur: "",
          action: "",
        },
      ],
    };
  },
  methods: {
    cancelBannerForm() {
      Object.assign(this.form, this.original_data);
    },
    async setSortData(data) {
      let obj1 = JSON.parse(JSON.stringify(data));
      for (let key in obj1) {
        for (let x in obj1[key]) {
          if (x != "banner_promotion_id" && x != "banner_promotion_series") {
            delete obj1[key][x];
          }
        }
        obj1[key].banner_promotion_series = parseFloat(key) + 1;
      }
      return obj1;
    },
    async saveSort() {
      this.sorting_data = true;
      let obj1 = await this.setSortData(this.data_for_sort);
      this.sort_msg = await this.$store.dispatch(
        "fetchFoodPromotionBack/sortPromoBanner",
        obj1
      );
      if (this.sort_msg != 3) {
        await this.initialize();
        this.sort_data = false;
        this.hideActionsTable = false;
      }
      this.sorting_data = false;
    },
    startSort() {
      this.hideActionsTable = true;
      this.data_for_sort = JSON.parse(JSON.stringify(this.promotion_banner));
      this.sort_data = true;
    },
    async cancelSortData() {
      this.cancel_sort = true;
      await this.initialize();
      this.cancel_sort = false;
      this.data_for_sort = {};
      this.sort_data = false;
      this.sort_msg = 0;
      this.hideActionsTable = false;
    },
    async deleteBanner(item) {
      let index = this.promotion_banner.indexOf(item);
      confirm("ยืนยันการลบรายการ") &&
        (await this.$store.dispatch(
          "fetchFoodPromotionBack/deletePromotionBanner",
          { form: item }
        ));
    },
    async changeStatusBanner(item) {
      let index = 0;
      let clone_obj = JSON.parse(JSON.stringify(item));
      for (let x in clone_obj) {
        let arr_split = x.split("_");
        if (arr_split[arr_split.length - 1] == "temp") {
          delete clone_obj[x];
        }
      }
      delete clone_obj.banner_promotion_image;
      let check = await this.$store.dispatch(
        "fetchFoodPromotionBack/editPromotionBanner",
        { form: clone_obj, index }
      );
      if (check == false) {
        item.banner_promotion_status = !item.banner_promotion_status;
      }
    },
    filterPromotionType(item) {
      if (item.banner_promotion_type == 1) {
        item.banner_promotion_type_name_temp = "Food delivery";
      } else if (item.banner_promotion_type == 2) {
        item.banner_promotion_type_name_temp = "Messenger";
      } else if (item.banner_promotion_type == 3) {
        item.banner_promotion_type_name_temp = "Free delivery";
      } else if (item.banner_promotion_type == 6){
        item.banner_promotion_type_name_temp = "Dine In";
      }
      return item.banner_promotion_type_name_temp;
    },
    editBanner(item) {
      if(item.banner_promotion_type == 6){
        let arr_store = [];
      if (
        item.banner_promotion_store.length > 0 &&
        item.banner_promotion_store[0] != 0
      ) {
        for (let val of item.banner_promotion_store) {
          let store = this.autocompleteStoreDinein.find(
            (val2) => val2.store_id == val
          );
          if (store) {
            arr_store.push(store);
          }
        }
      }
      this.original_data = JSON.parse(JSON.stringify(item));
      this.form = item;
      this.form.banner_promotion_store = arr_store;

      this.bannerDialog = true;
      this.editedIndex = 1;
      }else {
              let arr_store = [];
      if (
        item.banner_promotion_store.length > 0 &&
        item.banner_promotion_store[0] != 0
      ) {
        for (let val of item.banner_promotion_store) {
          let store = this.autocompleteStore.find(
            (val2) => val2.store_id == val
          );
          if (store) {
            arr_store.push(store);
          }
        }
      }
      this.original_data = JSON.parse(JSON.stringify(item));
      this.form = item;
      this.form.banner_promotion_store = arr_store;

      this.bannerDialog = true;
      this.editedIndex = 1;
      }
    },
    async fetchStoreList() {
      this.isLoadingStore = true;
      await this.$store.dispatch("fetchStoreBack/getStoreList");
      await this.$store.dispatch("fetchDineIn/getAllDineInStore", {
        page_size: 9999999999,
        current_page: 1,
      });
      this.isLoadingStore = false;
    },
    async initialize() {
      this.fetching_data = true;
      this.$store.commit("fetchFoodPromotionBack/getPromotionBanner", []);
      await this.$store.dispatch("fetchFoodPromotionBack/getPromotionBanner");
      this.fetching_data = false;
    },
  },
  computed: {
    ...mapState({
      promotion_banner: (state) =>
        state.fetchFoodPromotionBack.promotion_banner,
    }),
    ...mapGetters({
      autocompleteStore: "fetchStoreBack/autocompleteStore",
      autocompleteStoreDinein: 'fetchDineIn/autocompleteStoreDinein'
    }),
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    let table = document.querySelector(".v-datatable tbody");
    const _self = this;
    Sortable.create(table, {
      handle: ".handle",
      onEnd({ oldIndex, newIndex }) {
        const rowSelected = _self.data_for_sort.splice(oldIndex, 1)[0];
        _self.data_for_sort.splice(newIndex, 0, rowSelected);
      },
    });
  },
  created() {
    this.initialize();
    this.fetchStoreList();
  },
};
</script>

<style scoped>
.status_toggle {
  position: absolute;
  top: 3rem;
  left: 40%;
}
</style>
